import Vue from 'vue';
import Router from 'vue-router';

import Config from './config';

// 登录
import Home from '../views/home'
import Login from '../views/login'

// 学员
import Student from '../views/student';
import StudentDetail from '../views/student/Detail';
import StudentEdit from '../views/student/Edit';
import StudentUpdateRequestList from '../views/student/UpdateRequestList';
import StudentUpdateRecordList from '../views/student/UpdateRecordList';
import StudentUpdateRecordDetail from '../views/student/UpdateRecordDetail';
import StudentDeleteDetail from '../views/student/DeleteDetail';
import StudentAdd from '../views/student/Add';
import StudentRankList from '../views/student/RankList';
import StudentRankActivity from '../views/student-rank-activity/Index';
import StudentRankActivityDeletedList from '../views/student-rank-activity/DeletedList';
import StudentRankActivityAdd from '../views/student-rank-activity/Add';
import StudentRankActivityEdit from '../views/student-rank-activity/Edit';
import StudentRankActivityRankList from '../views/student-rank-activity/RankList';
import StudentRankLevel from '../views/student-rank-level/Index';
import StudentRankLevelDeletedList from '../views/student-rank-level/DeletedList';
import StudentRankLevelAdd from '../views/student-rank-level/Add';
import StudentRankLevelEdit from '../views/student-rank-level/Edit';
import StudentDeletedList from '../views/student/DeletedList';
import StudentDeletedDeletionRequestList from '../views/student/DeletionRequestList';
import StudentUpdateRequestDetail from '../views/student/UpdateRequestDetail';
import StudentDeletionRequestDetail from '../views/student/DeletionRequestDetail';

// 潜在学员
import LatentStudent from '../views/latent-student';
import LatentStudentBrowseList from '../views/latent-student/BrowseList';
import LatentStudentTrialList from '../views/latent-student/TrialList';

// 课卡
import Card from '../views/card';
import CardEditDate from '../views/card/EditDate';
import CardEditDateBatch from '../views/card/EditDateBatch';
import CardEditNumber from '../views/card/EditNumber';
import CardEditType from '../views/card/EditType';
import CardEdit from '../views/card/Edit';
import CardDetail from '../views/card/Detail';
import CardDelete from '../views/card/Delete';
import CardDeleteApplyList from '../views/card/DeleteApplyList';
import CardDeleteApplyDetail from '../views/card/DeleteApplyDetail';
import CardDeleteRecordDetail from '../views/card/DeleteRecordDetail';
import CardDeleteRecordEdit from '../views/card/DeleteRecordEdit';
import CardDeletedList from '../views/card/DeletedList';
import CardAdd from '../views/card/Add';
import CardAddApplyList from '../views/card/AddApplyList';
import CardUpdateApplyList from '../views/card/UpdateApplyList';
import CardAddApplyDetail from '../views/card/AddApplyDetail';
import CardAddApplyEdit from '../views/card/AddApplyEdit';
import CardUpdateApplyDetail from '../views/card/UpdateApplyDetail';
import CardUpdateRecordList from '../views/card/UpdateRecordList';
import CardUpdateRecordDetail from '../views/card/UpdateRecordDetail';

// 课程列表
import Course from '../views/course';
import CourseTodayList from '../views/course/TodayList';
import CourseEdit from '../views/course/Edit';
import CourseReserve from '../views/course/Reserve';
import CourseTrial from '../views/course/Trial';
import CourseManage from '../views/course/Manage';
import CourseAdd from '../views/course/Add';
import CourseDeletedList from '../views/course/DeletedList';
import CourseReservationRecordList from '../views/course/ReservationRecordList';

// 课表
import CourseSchedule from '../views/course-schedule';
import CourseScheduleDeletedList from '../views/course-schedule/DeletedList';
import CourseScheduleAdd from '../views/course-schedule/Add';
import CourseScheduleEdit from '../views/course-schedule/Edit';

// 发票
import Invoice from '../views/invoice';
import InvoiceAdd from '../views/invoice/Add';
import InvoiceDetail from '../views/invoice/Detail';

// 发票类目
import InvoiceClass from '../views/invoice-class';
import InvoiceClassDeletedList from '../views/invoice-class/DeletedList';
import InvoiceClassAdd from '../views/invoice-class/Add';
import InvoiceClassEdit from '../views/invoice-class/Edit';

// 日总结
import DailyReport from '../views/daily-report';
import DailyReportDetail from '../views/daily-report/Detail';
import DailyReportEdit from '../views/daily-report/Edit';
import DailyReportAdd from '../views/daily-report/Add';

// 日总结
import Video from '../views/video';
import VideoDeletedList from '../views/video/DeletedList';
import VideoAdd from '../views/video/Add';
import VideoEdit from '../views/video/Edit';

// 课程标签
import CourseTag from '../views/course-tag';
import CourseTagDeletedList from '../views/course-tag/DeletedList';
import CourseTagAdd from '../views/course-tag/Add';
import CourseTagEdit from '../views/course-tag/Edit';

// 课程专栏
import CourseColumn from '../views/course-column';
import CourseColumnDeletedList from '../views/course-column/DeletedList';
import CourseColumnAdd from '../views/course-column/Add';
import CourseColumnEdit from '../views/course-column/Edit';
import CourseColumnManage from '../views/course-column/Manage';

// 老师
import Teacher from '../views/teacher';
import TeacherDeletedList from '../views/teacher/DeletedList';
import TeacherSalaryList from '../views/teacher/SalaryList';
import TeacherSalaryRecordList from '../views/teacher/SalaryRecordList';
import TeacherStageNumberEdit from '../views/teacher/StageNumberEdit';
import TeacherStageSalaryEdit from '../views/teacher/StageSalaryEdit';
import TeacherRankList from '../views/teacher/RankList';
import TeacherAddApplyList from '../views/teacher/AddApplyList';
import TeacherAddApplyDetail from '../views/teacher/AddApplyDetail';
import TeacherAdd from '../views/teacher/Add';
import TeacherEdit from '../views/teacher/Edit';
import TeacherDetail from '../views/teacher/Detail';
import TeacherSalaryAdd from '../views/teacher/SalaryAdd';
import TeacherSalaryEdit from '../views/teacher/SalaryEdit';

// 积分活动
import IntegralActivity from '../views/integral-activity';
import IntegralActivityDeletedList from '../views/integral-activity/DeletedList';
import IntegralActivityAdd from '../views/integral-activity/Add';
import IntegralActivityEdit from '../views/integral-activity/Edit';


// 积分活动目标
import IntegralActivityTarget from '../views/integral-activity-target';
import IntegralActivityTargetDeletedList from '../views/integral-activity-target/DeletedList';
import IntegralActivityTargetAdd from '../views/integral-activity-target/Add';
import IntegralActivityTargetEdit from '../views/integral-activity-target/Edit';
import IntegralActivityTargetEntityReceiveManage from '../views/integral-activity-target/EntityReceiveManage';

// 管理员
import Administrator from '../views/administrator';
import AdministratorDeletedList from '../views/administrator/DeletedList';
import AdministratorLoginRecordList from '../views/administrator/LoginRecordList';
import AdministratorViewRecordList from '../views/administrator/ViewRecordList';
import AdministratorSalaryList from '../views/administrator/SalaryList';
import AdministratorAdd from '../views/administrator/Add';
import AdministratorEditPassword from '../views/administrator/EditPassword';
import AdministratorEditPasswordByAdministrator from '../views/administrator/EditPasswordByAdministrator';
import AdministratorSalaryAdd from '../views/administrator/SalaryAdd';
import AdministratorSalaryEdit from '../views/administrator/SalaryEdit';
import AdministratorEdit from '../views/administrator/Edit';
import AdministratorProfile from '../views/administrator/Profile';
import AdministratorInviteList from '../views/administrator/InviteList';
import AdministratorInviteDetail from '../views/administrator/InviteDetail';
import AdministratorOnboardApplyList from '../views/administrator/OnboardApplyList';
import AdministratorOnboardApplyDetail from '../views/administrator/OnboardApplyDetail';
import AdministratorOffboardApplyList from '../views/administrator/OffboardApplyList';
import AdministratorOffboardApplyDetail from '../views/administrator/OffboardApplyDetail';
import AdministratorOperationLog from '../views/administrator/OperationLog';
import AdministratorOperationLogDetail from '../views/administrator/OperationLogDetail';
import Onboard from '../views/onboard/Index';


// 月总结
import MonthlyReport from '../views/monthly-report';
import MonthlyReportAdd from '../views/monthly-report/Add';
import MonthlyReportDetail from '../views/monthly-report/Detail';
import MonthlyReportEdit from '../views/monthly-report/Edit';
import MonthlyReportRankList from '../views/monthly-report/RankList';

// 办公室月总结
import OfficeMonthlyReport from '../views/office-monthly-report';
import OfficeMonthlyReportAdd from '../views/office-monthly-report/Add';
import OfficeMonthlyReportDetail from '../views/office-monthly-report/Detail';
import OfficeMonthlyReportEdit from '../views/office-monthly-report/Edit';

// 课卡类型
import CardChargeType from '../views/card-charge-type';
import CardChargeTypeDeletedList from '../views/card-charge-type/DeletedList';
import CardChargeTypeAdd from '../views/card-charge-type/Add';
import CardChargeTypeEdit from '../views/card-charge-type/Edit';
import CardChargeTypeYearlyAnalysis from '../views/card-charge-type/YearlyAnalysis';

// 课次券类型
import CardTicketType from '../views/card-ticket-type';
import CardTicketTypeDeletedList from '../views/card-ticket-type/DeletedList';
import CardTicketTypeAdd from '../views/card-ticket-type/Add';
import CardTicketTypeEdit from '../views/card-ticket-type/Edit';

// 代金券类型
import VoucherType from '../views/voucher-type';
import VoucherTypeDeletedList from '../views/voucher-type/DeletedList';
import VoucherTypeAdd from '../views/voucher-type/Add';
import VoucherTypeEdit from '../views/voucher-type/Edit';
import Voucher from '../views/voucher';
import VoucherDeletedList from '../views/voucher/DeletedList';
import VoucherAdd from '../views/voucher/Add';
import VoucherDetail from '../views/voucher/Detail';
import VoucherAddApplyList from '../views/voucher/AddApplyList';
import VoucherAddApplyDetail from '../views/voucher/AddApplyDetail';
import VoucherDelete from '../views/voucher/Delete';

// 课次券
import CardTicket from '../views/card-ticket';
import CardTicketDeletedList from '../views/card-ticket/DeletedList';
import CardTicketUpdateRecordList from '../views/card-ticket/UpdateRecordList';
import CardTicketAdd from '../views/card-ticket/Add';
import CardTicketAddApplyList from '../views/card-ticket/AddApplyList';
import CardTicketDetail from '../views/card-ticket/Detail';
import CardTicketAddApplyDetail from '../views/card-ticket/AddApplyDetail';
import CardTicketEditDate from '../views/card-ticket/EditDate';
import CardTicketEditNumber from '../views/card-ticket/EditNumber';
import CardTicketDelete from '../views/card-ticket/Delete';
import CardTicketDeleteRecordDetail from '../views/card-ticket/DeleteRecordDetail';

// 轮播图
import Banner from '../views/banner';
import BannerDeletedList from '../views/banner/DeletedList';
import BannerAdd from '../views/banner/Add';
import BannerEdit from '../views/banner/Edit';

// 课程风格
import CourseStyle from '../views/course-style';
import CourseStyleDeletedList from '../views/course-style/DeletedList';
import CourseStyleAddApplyList from '../views/course-style/AddApplyList';
import CourseStyleAdd from '../views/course-style/Add';
import CourseStyleEdit from '../views/course-style/Edit';
import CourseStyleAddApplyDetail from '../views/course-style/AddApplyDetail';

// 课程难度
import CourseDifficulty from '../views/course-difficulty';
import CourseDifficultyDeletedList from '../views/course-difficulty/DeletedList';
import CourseDifficultyAddApplyList from '../views/course-difficulty/AddApplyList';
import CourseDifficultyAdd from '../views/course-difficulty/Add';
import CourseDifficultyEdit from '../views/course-difficulty/Edit';
import CourseDifficultyAddApplyDetail from '../views/course-difficulty/AddApplyDetail';

// 课程注意事项
import CourseTip from '../views/course-tip';
import CourseTipDeletedList from '../views/course-tip/DeletedList';
import CourseTipAdd from '../views/course-tip/Add';
import CourseTipEdit from '../views/course-tip/Edit';

// 课程白名单
import CourseWhitelist from '../views/course-whitelist';
import CourseWhitelistDeletedList from '../views/course-whitelist/DeletedList';
import CourseWhitelistAdd from '../views/course-whitelist/Add';
import CourseWhitelistManage from '../views/course-whitelist/Manage';

// 课程封面
import CourseCover from '../views/course-cover';
import CourseCoverDeletedList from '../views/course-cover/DeletedList';
import CourseCoverAdd from '../views/course-cover/Add';
import CourseCoverEdit from '../views/course-cover/Edit';

// 课程封面视频
import CourseVideo from '../views/course-video';
import CourseVideoDeletedList from '../views/course-video/DeletedList';
import CourseVideoAdd from '../views/course-video/Add';
import CourseVideoEdit from '../views/course-video/Edit';

// 门店
import Store from '../views/store';
import StoreQrCode from '../views/store-qr-code';
import StoreDeletedList from '../views/store/DeletedList';
import StoreAdd from '../views/store/Add';
import StoreEdit from '../views/store/Edit';

// 门店封面
/*import StoreCover from '../views/store-cover';
import StoreCoverDeletedList from '../views/store-cover/DeletedList';
import StoreCoverAdd from '../views/store-cover/Add';
import StoreCoverEdit from '../views/store-cover/Edit';*/

// 微信支付订单
import WeChatOrder from '../views/we-chat-order/index';
import WeChatOrderRefundList from '../views/we-chat-order/RefundList';

// 有赞签到日期
import YouZanSignDate from '../views/you-zan-sign-date/index';
import YouZanSignDateDeletedList from '../views/you-zan-sign-date/DeletedList';
import YouZanSignDateVerifiedList from '../views/you-zan-sign-date/VerifiedList';
import YouZanSignDateSignedList from '../views/you-zan-sign-date/SignedList';
import YouZanSignDateAdd from '../views/you-zan-sign-date/Add';
import YouZanSignDateEdit from '../views/you-zan-sign-date/Edit';

// 错误日志列表
import ErrorLog from '../views/error-log';
import ErrorLogDetail from '../views/error-log/Detail';
import ErrorLogYouZanList from '../views/error-log/YouZanList';
import ErrorWeChatOrderList from '../views/error-log/WeChatOrderList';
import ErrorLogYouZanDetail from '../views/error-log/YouZanDetail';
import ErrorLogWeChatOrderDetail from '../views/error-log/WeChatOrderDetail';
import ErrorWorkWeChatList from '../views/error-log/WorkWeChatList';
import ErrorWorkWeChatDetail from '../views/error-log/WorkWeChatDetail';
import ErrorWeChatSubscribeList from '../views/error-log/WeChatSubscribeList';
import ErrorSmsList from '../views/error-log/SmsList';

// 小程序页面
import AppPage from '../views/app-page';
import AppPageDeletedList from '../views/app-page/DeletedList';
import AppPageAdd from '../views/app-page/Add';
import AppPageEdit from '../views/app-page/Edit';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  routes: [
    {
      name: Config.home.name,
      path: Config.home.path,
      component: Home,
    },
    {
      name: Config.login.name,
      path: Config.login.path,
      component: Login,
    },

    // 学员相关
    {
      name: Config.studentList.name,
      path: Config.studentList.path,
      component: Student,
    },

    {
      name: Config.studentRankList.name,
      path: Config.studentRankList.path,
      component: StudentRankList,
    },

    // 舞者等级活动
    {
      name: Config.studentRankActivityList.name,
      path: Config.studentRankActivityList.path,
      component: StudentRankActivity,
    },

    {
      name: Config.studentRankActivityDeletedList.name,
      path: Config.studentRankActivityDeletedList.path,
      component: StudentRankActivityDeletedList,
    },

    {
      name: Config.studentRankActivityAdd.name,
      path: Config.studentRankActivityAdd.path,
      component: StudentRankActivityAdd,
    },

    {
      name: Config.studentRankActivityEdit.name,
      path: Config.studentRankActivityEdit.path,
      component: StudentRankActivityEdit,
    },

    {
      name: Config.studentRankActivityRankList.name,
      path: Config.studentRankActivityRankList.path,
      component: StudentRankActivityRankList,
    },

    // 舞者等级字典
    {
      name: Config.studentRankLevelList.name,
      path: Config.studentRankLevelList.path,
      component: StudentRankLevel,
    },

    {
      name: Config.studentRankLevelDeletedList.name,
      path: Config.studentRankLevelDeletedList.path,
      component: StudentRankLevelDeletedList,
    },

    {
      name: Config.studentRankLevelAdd.name,
      path: Config.studentRankLevelAdd.path,
      component: StudentRankLevelAdd,
    },

    {
      name: Config.studentRankLevelEdit.name,
      path: Config.studentRankLevelEdit.path,
      component: StudentRankLevelEdit,
    },

    {
      path: Config.studentDetail.path,
      name: Config.studentDetail.name,
      component: StudentDetail,
    },

    {
      path: Config.studentEdit.path,
      name: Config.studentEdit.name,
      component: StudentEdit,
    },

    {
      path: Config.studentUpdateRecordDetail.path,
      name: Config.studentUpdateRecordDetail.name,
      component: StudentUpdateRecordDetail,
    },

    {
      path: Config.studentDeleteDetail.path,
      name: Config.studentDeleteDetail.name,
      component: StudentDeleteDetail,
    },

    {
      path: Config.studentAdd.path,
      name: Config.studentAdd.name,
      component: StudentAdd,
    },

    {
      path: Config.studentUpdateRequestList.path,
      name: Config.studentUpdateRequestList.name,
      component: StudentUpdateRequestList,
    },
    {
      path: Config.studentUpdateRequestDetail.path,
      name: Config.studentUpdateRequestDetail.name,
      component: StudentUpdateRequestDetail,
    },

    {
      path: Config.studentUpdateRecordList.path,
      name: Config.studentUpdateRecordList.name,
      component: StudentUpdateRecordList,
    },



    {
      path: Config.studentDeletedList.path,
      name: Config.studentDeletedList.name,
      component: StudentDeletedList,
    },

    {
      path: Config.studentDeletionRequestList.path,
      name: Config.studentDeletionRequestList.name,
      component: StudentDeletedDeletionRequestList,
    },

    {
      path: Config.studentDeletionRequestDetail.path,
      name: Config.studentDeletionRequestDetail.name,
      component: StudentDeletionRequestDetail,
    },

    // 潜在学员
    {
      path: Config.latentStudentList.path,
      name: Config.latentStudentList.name,
      component: LatentStudent,
    },
    {
      path: Config.latentStudentBrowseList.path,
      name: Config.latentStudentBrowseList.name,
      component: LatentStudentBrowseList,
    },
    {
      path: Config.latentStudentTrailList.path,
      name: Config.latentStudentTrailList.name,
      component: LatentStudentTrialList,
    },

     // 课卡
    {
      path: Config.cardList.path,
      name: Config.cardList.name,
      component: Card,
    },
    {
      path: Config.cardEditDate.path,
      name: Config.cardEditDate.name,
      component: CardEditDate,
    },
    {
      path: Config.cardEditDateBatch.path,
      name: Config.cardEditDateBatch.name,
      component: CardEditDateBatch,
    },
    {
      path: Config.cardEditNumber.path,
      name: Config.cardEditNumber.name,
      component: CardEditNumber,
    },
    {
      path: Config.cardEditType.path,
      name: Config.cardEditType.name,
      component: CardEditType,
    },
    {
      path: Config.cardEdit.path,
      name: Config.cardEdit.name,
      component: CardEdit,
    },
    {
      path: Config.cardDetail.path,
      name: Config.cardDetail.name,
      component: CardDetail,
    },
    {
      path: Config.cardDelete.path,
      name: Config.cardDelete.name,
      component: CardDelete,
    },
    {
      path: Config.cardDeleteApplyList.path,
      name: Config.cardDeleteApplyList.name,
      component: CardDeleteApplyList,
    },
    {
      path: Config.cardDeleteApplyDetail.path,
      name: Config.cardDeleteApplyDetail.name,
      component: CardDeleteApplyDetail,
    },
    {
      path: Config.cardDeleteRecordDetail.path,
      name: Config.cardDeleteRecordDetail.name,
      component: CardDeleteRecordDetail,
    },
    {
      path: Config.cardDeleteRecordEdit.path,
      name: Config.cardDeleteRecordEdit.name,
      component: CardDeleteRecordEdit,
    },
    {
      path: Config.cardDeletedList.path,
      name: Config.cardDeletedList.name,
      component: CardDeletedList,
    },
    {
      path: Config.cardAdd.path,
      name: Config.cardAdd.name,
      component: CardAdd,
    },
    {
      path: Config.cardAddApplyList.path,
      name: Config.cardAddApplyList.name,
      component: CardAddApplyList,
    },
    {
      path: Config.cardUpdateApplyList.path,
      name: Config.cardUpdateApplyList.name,
      component: CardUpdateApplyList,
    },
    {
      path: Config.cardAddApplyDetail.path,
      name: Config.cardAddApplyDetail.name,
      component: CardAddApplyDetail,
    },
    {
      path: Config.cardAddApplyEdit.path,
      name: Config.cardAddApplyEdit.name,
      component: CardAddApplyEdit,
    },
    {
      path: Config.cardUpdateApplyDetail.path,
      name: Config.cardUpdateApplyDetail.name,
      component: CardUpdateApplyDetail,
    },
    {
      path: Config.cardUpdateRecordList.path,
      name: Config.cardUpdateRecordList.name,
      component: CardUpdateRecordList,
    },
    {
      path: Config.cardUpdateRecordDetail.path,
      name: Config.cardUpdateRecordDetail.name,
      component: CardUpdateRecordDetail,
    },

    // 课程
    {
      path: Config.courseList.path,
      name: Config.courseList.name,
      component: Course,
    },
    {
      path: Config.courseTodayList.path,
      name: Config.courseTodayList.name,
      component: CourseTodayList,
    },
    {
      path: Config.courseEdit.path,
      name: Config.courseEdit.name,
      component: CourseEdit,
    },
    {
      path: Config.courseReserve.path,
      name: Config.courseReserve.name,
      component: CourseReserve,
    },
    {
      path: Config.courseTrial.path,
      name: Config.courseTrial.name,
      component: CourseTrial,
    },
    {
      path: Config.courseManage.path,
      name: Config.courseManage.name,
      component: CourseManage,
    },
    {
      path: Config.courseAdd.path,
      name: Config.courseAdd.name,
      component: CourseAdd,
    },
    {
      path: Config.courseDeletedList.path,
      name: Config.courseDeletedList.name,
      component: CourseDeletedList,
    },
    {
      path: Config.courseReservationRecordList.path,
      name: Config.courseReservationRecordList.name,
      component: CourseReservationRecordList,
    },


    // 课表
    {
      path: Config.courseScheduleList.path,
      name: Config.courseScheduleList.name,
      component: CourseSchedule,
    },
    {
      path: Config.courseScheduleDeletedList.path,
      name: Config.courseScheduleDeletedList.name,
      component: CourseScheduleDeletedList,
    },
    {
      path: Config.courseScheduleAdd.path,
      name: Config.courseScheduleAdd.name,
      component: CourseScheduleAdd,
    },
    {
      path: Config.courseScheduleEdit.path,
      name: Config.courseScheduleEdit.name,
      component: CourseScheduleEdit,
    },

    // 发票
    {
      path: Config.invoiceList.path,
      name: Config.invoiceList.name,
      component: Invoice,
    },
    {
      path: Config.invoiceAdd.path,
      name: Config.invoiceAdd.name,
      component: InvoiceAdd,
    },
    {
      path: Config.invoiceDetail.path,
      name: Config.invoiceDetail.name,
      component: InvoiceDetail,
    },

    // 发票类目
    {
      path: Config.invoiceClassList.path,
      name: Config.invoiceClassList.name,
      component: InvoiceClass,
    },
    {
      path: Config.invoiceClassDeletedList.path,
      name: Config.invoiceClassDeletedList.name,
      component: InvoiceClassDeletedList,
    },
    {
      path: Config.invoiceClassAdd.path,
      name: Config.invoiceClassAdd.name,
      component: InvoiceClassAdd,
    },
    {
      path: Config.invoiceClassEdit.path,
      name: Config.invoiceClassEdit.name,
      component: InvoiceClassEdit,
    },

    // 日总结
    {
      path: Config.dailyReportList.path,
      name: Config.dailyReportList.name,
      component: DailyReport,
    },
    {
      path: Config.dailyReportDetail.path,
      name: Config.dailyReportDetail.name,
      component: DailyReportDetail,
    },
    {
      path: Config.dailyReportEdit.path,
      name: Config.dailyReportEdit.name,
      component: DailyReportEdit,
    },
    {
      path: Config.dailyReportAdd.path,
      name: Config.dailyReportAdd.name,
      component: DailyReportAdd,
    },

    // 视频
    {
      path: Config.videoList.path,
      name: Config.videoList.name,
      component: Video,
    },
    {
      path: Config.videoDeletedList.path,
      name: Config.videoDeletedList.name,
      component: VideoDeletedList,
    },
    {
      path: Config.videoAdd.path,
      name: Config.videoAdd.name,
      component: VideoAdd,
    },
    {
      path: Config.videoEdit.path,
      name: Config.videoEdit.name,
      component: VideoEdit,
    },

    // 课程标签
    {
      path: Config.courseTagList.path,
      name: Config.courseTagList.name,
      component: CourseTag,
    },
    {
      path: Config.courseTagDeletedList.path,
      name: Config.courseTagDeletedList.name,
      component: CourseTagDeletedList,
    },
    {
      path: Config.courseTagAdd.path,
      name: Config.courseTagAdd.name,
      component: CourseTagAdd,
    },
    {
      path: Config.courseTagEdit.path,
      name: Config.courseTagEdit.name,
      component: CourseTagEdit,
    },


    // 课程专栏
    {
      path: Config.courseColumnList.path,
      name: Config.courseColumnList.name,
      component: CourseColumn,
    },
    {
      path: Config.courseColumnDeletedList.path,
      name: Config.courseColumnDeletedList.name,
      component: CourseColumnDeletedList,
    },
    {
      path: Config.courseColumnAdd.path,
      name: Config.courseColumnAdd.name,
      component: CourseColumnAdd,
    },
    {
      path: Config.courseColumnEdit.path,
      name: Config.courseColumnEdit.name,
      component: CourseColumnEdit,
    },
    {
      path: Config.courseColumnManage.path,
      name: Config.courseColumnManage.name,
      component: CourseColumnManage,
    },

    // 老师
    {
      path: Config.teacherList.path,
      name: Config.teacherList.name,
      component: Teacher,
    },
    {
      path: Config.teacherDeletedList.path,
      name: Config.teacherDeletedList.name,
      component: TeacherDeletedList,
    },
    {
      path: Config.teacherSalaryList.path,
      name: Config.teacherSalaryList.name,
      component: TeacherSalaryList,
    },
    {
      path: Config.teacherSalaryRecordList.path,
      name: Config.teacherSalaryRecordList.name,
      component: TeacherSalaryRecordList,
    },
    {
      path: Config.teacherStageSalaryEdit.path,
      name: Config.teacherStageSalaryEdit.name,
      component: TeacherStageSalaryEdit,
    },
    {
      path: Config.teacherStageNumberEdit.path,
      name: Config.teacherStageNumberEdit.name,
      component: TeacherStageNumberEdit,
    },
    {
      path: Config.teacherRankList.path,
      name: Config.teacherRankList.name,
      component: TeacherRankList,
    },
    {
      path: Config.teacherAddApplyList.path,
      name: Config.teacherAddApplyList.name,
      component: TeacherAddApplyList,
    },
    {
      path: Config.teacherAddApplyDetail.path,
      name: Config.teacherAddApplyDetail.name,
      component: TeacherAddApplyDetail,
    },
    {
      path: Config.teacherAdd.path,
      name: Config.teacherAdd.name,
      component: TeacherAdd,
    },
    {
      path: Config.teacherEdit.path,
      name: Config.teacherEdit.name,
      component: TeacherEdit,
    },
    {
      path: Config.teacherDetail.path,
      name: Config.teacherDetail.name,
      component: TeacherDetail,
    },
    {
      path: Config.teacherSalaryAdd.path,
      name: Config.teacherSalaryAdd.name,
      component: TeacherSalaryAdd,
    },
    {
      path: Config.teacherSalaryEdit.path,
      name: Config.teacherSalaryEdit.name,
      component: TeacherSalaryEdit,
    },

    // 积分活动
    {
      name: Config.integralActivityList.name,
      path: Config.integralActivityList.path,
      component: IntegralActivity,
    },
    {
      name: Config.integralActivityDeletedList.name,
      path: Config.integralActivityDeletedList.path,
      component: IntegralActivityDeletedList,
    },
    {
      name: Config.integralActivityAdd.name,
      path: Config.integralActivityAdd.path,
      component: IntegralActivityAdd,
    },
    {
      name: Config.integralActivityEdit.name,
      path: Config.integralActivityEdit.path,
      component: IntegralActivityEdit,
    },

    // 积分活动目标
    {
      name: Config.integralActivityTargetList.name,
      path: Config.integralActivityTargetList.path,
      component: IntegralActivityTarget,
    },
    {
      name: Config.integralActivityTargetDeletedList.name,
      path: Config.integralActivityTargetDeletedList.path,
      component: IntegralActivityTargetDeletedList,
    },
    {
      name: Config.integralActivityTargetAdd.name,
      path: Config.integralActivityTargetAdd.path,
      component: IntegralActivityTargetAdd,
    },
    {
      name: Config.integralActivityTargetEdit.name,
      path: Config.integralActivityTargetEdit.path,
      component: IntegralActivityTargetEdit,
    },
    {
      name: Config.integralActivityTargetEntityReceiveManage.name,
      path: Config.integralActivityTargetEntityReceiveManage.path,
      component: IntegralActivityTargetEntityReceiveManage,
    },

    // 管理员
    {
      name: Config.administratorList.name,
      path: Config.administratorList.path,
      component: Administrator,
    },
    {
      name: Config.administratorDeletedList.name,
      path: Config.administratorDeletedList.path,
      component: AdministratorDeletedList,
    },
    {
      name: Config.administratorLoginRecordList.name,
      path: Config.administratorLoginRecordList.path,
      component: AdministratorLoginRecordList,
    },
    {
      name: Config.administratorViewRecordList.name,
      path: Config.administratorViewRecordList.path,
      component: AdministratorViewRecordList,
    },
    {
      name: Config.administratorSalaryList.name,
      path: Config.administratorSalaryList.path,
      component: AdministratorSalaryList,
    },
    {
      name: Config.administratorAdd.name,
      path: Config.administratorAdd.path,
      component: AdministratorAdd,
    },
    {
      name: Config.administratorEdit.name,
      path: Config.administratorEdit.path,
      component: AdministratorEdit,
    },
    {
      name: Config.administratorEditPassword.name,
      path: Config.administratorEditPassword.path,
      component: AdministratorEditPassword,
    },
    {
      name: Config.administratorEditPasswordByAdministrator.name,
      path: Config.administratorEditPasswordByAdministrator.path,
      component: AdministratorEditPasswordByAdministrator,
    },
    {
      name: Config.administratorSalaryAdd.name,
      path: Config.administratorSalaryAdd.path,
      component: AdministratorSalaryAdd,
    },
    {
      name: Config.administratorSalaryEdit.name,
      path: Config.administratorSalaryEdit.path,
      component: AdministratorSalaryEdit,
    },

    {
      name: Config.administratorProfile.name,
      path: Config.administratorProfile.path,
      component: AdministratorProfile,
    },
    {
      name: Config.administratorInviteList.name,
      path: Config.administratorInviteList.path,
      component: AdministratorInviteList,
    },
    {
      name: Config.administratorInviteDetail.name,
      path: Config.administratorInviteDetail.path,
      component: AdministratorInviteDetail,
    },
    {
      name: Config.administratorOnboardApplyList.name,
      path: Config.administratorOnboardApplyList.path,
      component: AdministratorOnboardApplyList,
    },
    {
      name: Config.administratorOnboardApplyDetail.name,
      path: Config.administratorOnboardApplyDetail.path,
      component: AdministratorOnboardApplyDetail,
    },
    {
      name: Config.administratorOffboardApplyList.name,
      path: Config.administratorOffboardApplyList.path,
      component: AdministratorOffboardApplyList,
    },
    {
      name: Config.administratorOffboardApplyDetail.name,
      path: Config.administratorOffboardApplyDetail.path,
      component: AdministratorOffboardApplyDetail,
    },
    {
      name: Config.administratorOperationLogList.name,
      path: Config.administratorOperationLogList.path,
      component: AdministratorOperationLog,
    },
    {
      name: Config.administratorOperationLogDetail.name,
      path: Config.administratorOperationLogDetail.path,
      component: AdministratorOperationLogDetail,
    },
    {
      name: Config.onboard.name,
      path: Config.onboard.path,
      component: Onboard,
    },


    // 月度总结
    {
      path: Config.monthlyReportList.path,
      name: Config.monthlyReportList.name,
      component: MonthlyReport,
    },
    {
      path: Config.monthlyReportAdd.path,
      name: Config.monthlyReportAdd.name,
      component: MonthlyReportAdd,
    },
    {
      path: Config.monthlyReportDetail.path,
      name: Config.monthlyReportDetail.name,
      component: MonthlyReportDetail,
    },
    {
      path: Config.monthlyReportEdit.path,
      name: Config.monthlyReportEdit.name,
      component: MonthlyReportEdit,
    },
    {
      path: Config.monthlyReportRankList.path,
      name: Config.monthlyReportRankList.name,
      component: MonthlyReportRankList,
    },

    // 办公室月度总结
    {
      path: Config.officeMonthlyReportList.path,
      name: Config.officeMonthlyReportList.name,
      component: OfficeMonthlyReport,
    },
    {
      path: Config.officeMonthlyReportAdd.path,
      name: Config.officeMonthlyReportAdd.name,
      component: OfficeMonthlyReportAdd,
    },
    {
      path: Config.officeMonthlyReportDetail.path,
      name: Config.officeMonthlyReportDetail.name,
      component: OfficeMonthlyReportDetail,
    },
    {
      path: Config.officeMonthlyReportEdit.path,
      name: Config.officeMonthlyReportEdit.name,
      component: OfficeMonthlyReportEdit,
    },

    // 课卡收费类型
    {
      path: Config.cardChargeTypeList.path,
      name: Config.cardChargeTypeList.name,
      component: CardChargeType,
    },
    {
      path: Config.cardChargeTypeDeletedList.path,
      name: Config.cardChargeTypeDeletedList.name,
      component: CardChargeTypeDeletedList,
    },
    {
      path: Config.cardChargeTypeAdd.path,
      name: Config.cardChargeTypeAdd.name,
      component: CardChargeTypeAdd,
    },
    {
      path: Config.cardChargeTypeEdit.path,
      name: Config.cardChargeTypeEdit.name,
      component: CardChargeTypeEdit,
    },
    {
      path: Config.cardChargeTypeYearlyAnalysis.path,
      name: Config.cardChargeTypeYearlyAnalysis.name,
      component: CardChargeTypeYearlyAnalysis,
    },

    // 课次券类型
    {
      path: Config.cardTicketTypeList.path,
      name: Config.cardTicketTypeList.name,
      component: CardTicketType,
    },
    {
      path: Config.cardTicketTypeDeletedList.path,
      name: Config.cardTicketTypeDeletedList.name,
      component: CardTicketTypeDeletedList,
    },
    {
      path: Config.cardTicketTypeAdd.path,
      name: Config.cardTicketTypeAdd.name,
      component: CardTicketTypeAdd,
    },
    {
      path: Config.cardTicketTypeEdit.path,
      name: Config.cardTicketTypeEdit.name,
      component: CardTicketTypeEdit,
    },

    // 代金券类型
    {
      path: Config.voucherTypeList.path,
      name: Config.voucherTypeList.name,
      component: VoucherType,
    },
    {
      path: Config.voucherTypeDeletedList.path,
      name: Config.voucherTypeDeletedList.name,
      component: VoucherTypeDeletedList,
    },
    {
      path: Config.voucherTypeAdd.path,
      name: Config.voucherTypeAdd.name,
      component: VoucherTypeAdd,
    },
    {
      path: Config.voucherTypeEdit.path,
      name: Config.voucherTypeEdit.name,
      component: VoucherTypeEdit,
    },

    // 代金券
    {
      path: Config.voucherList.path,
      name: Config.voucherList.name,
      component: Voucher,
    },
    {
      path: Config.voucherDeletedList.path,
      name: Config.voucherDeletedList.name,
      component: VoucherDeletedList,
    },
    {
      path: Config.voucherAdd.path,
      name: Config.voucherAdd.name,
      component: VoucherAdd,
    },
    {
      path: Config.voucherAddApplyList.path,
      name: Config.voucherAddApplyList.name,
      component: VoucherAddApplyList,
    },
    {
      path: Config.voucherDetail.path,
      name: Config.voucherDetail.name,
      component: VoucherDetail,
    },
    {
      path: Config.voucherDelete.path,
      name: Config.voucherDelete.name,
      component: VoucherDelete,
    },
    {
      path: Config.voucherAddApplyDetail.path,
      name: Config.voucherAddApplyDetail.name,
      component: VoucherAddApplyDetail,
    },

    // 课次券
    {
      path: Config.cardTicketList.path,
      name: Config.cardTicketList.name,
      component: CardTicket,
    },
    {
      path: Config.cardTicketDeletedList.path,
      name: Config.cardTicketDeletedList.name,
      component: CardTicketDeletedList,
    },
    {
      path: Config.cardTicketUpdateRecordList.path,
      name: Config.cardTicketUpdateRecordList.name,
      component: CardTicketUpdateRecordList,
    },
    {
      path: Config.cardTicketAdd.path,
      name: Config.cardTicketAdd.name,
      component: CardTicketAdd,
    },
    {
      path: Config.cardTicketAddApplyList.path,
      name: Config.cardTicketAddApplyList.name,
      component: CardTicketAddApplyList,
    },
    {
      path: Config.cardTicketDetail.path,
      name: Config.cardTicketDetail.name,
      component: CardTicketDetail,
    },
    {
      path: Config.cardTicketAddApplyDetail.path,
      name: Config.cardTicketAddApplyDetail.name,
      component: CardTicketAddApplyDetail,
    },
    {
      path: Config.cardTicketEditDate.path,
      name: Config.cardTicketEditDate.name,
      component: CardTicketEditDate,
    },
    {
      path: Config.cardTicketEditNumber.path,
      name: Config.cardTicketEditNumber.name,
      component: CardTicketEditNumber,
    },
    {
      path: Config.cardTicketDelete.path,
      name: Config.cardTicketDelete.name,
      component: CardTicketDelete,
    },
    {
      path: Config.cardTicketDeleteRecordDetail.path,
      name: Config.cardTicketDeleteRecordDetail.name,
      component: CardTicketDeleteRecordDetail,
    },


    // 轮播图
    {
      path: Config.bannerList.path,
      name: Config.bannerList.name,
      component: Banner,
    },
    {
      path: Config.bannerDeletedList.path,
      name: Config.bannerDeletedList.name,
      component: BannerDeletedList,
    },
    {
      path: Config.bannerAdd.path,
      name: Config.bannerAdd.name,
      component: BannerAdd,
    },
    {
      path: Config.bannerEdit.path,
      name: Config.bannerEdit.name,
      component: BannerEdit,
    },

    // 课程舞蹈风格
    {
      path: Config.courseStyleList.path,
      name: Config.courseStyleList.name,
      component: CourseStyle,
    },
    {
      path: Config.courseStyleDeletedList.path,
      name: Config.courseStyleDeletedList.name,
      component: CourseStyleDeletedList,
    },
    {
      path: Config.courseStyleAddApplyList.path,
      name: Config.courseStyleAddApplyList.name,
      component: CourseStyleAddApplyList,
    },
    {
      path: Config.courseStyleAddApplyDetail.path,
      name: Config.courseStyleAddApplyDetail.name,
      component: CourseStyleAddApplyDetail,
    },
    {
      path: Config.courseStyleAdd.path,
      name: Config.courseStyleAdd.name,
      component: CourseStyleAdd,
    },
    {
      path: Config.courseStyleEdit.path,
      name: Config.courseStyleEdit.name,
      component: CourseStyleEdit,
    },

    // 课程难度
    {
      path: Config.courseDifficultyList.path,
      name: Config.courseDifficultyList.name,
      component: CourseDifficulty,
    },
    {
      path: Config.courseDifficultyDeletedList.path,
      name: Config.courseDifficultyDeletedList.name,
      component: CourseDifficultyDeletedList,
    },
    {
      path: Config.courseDifficultyAddApplyList.path,
      name: Config.courseDifficultyAddApplyList.name,
      component: CourseDifficultyAddApplyList,
    },
    {
      path: Config.courseDifficultyAddApplyDetail.path,
      name: Config.courseDifficultyAddApplyDetail.name,
      component: CourseDifficultyAddApplyDetail,
    },
    {
      path: Config.courseDifficultyAdd.path,
      name: Config.courseDifficultyAdd.name,
      component: CourseDifficultyAdd,
    },
    {
      path: Config.courseDifficultyEdit.path,
      name: Config.courseDifficultyEdit.name,
      component: CourseDifficultyEdit,
    },

    // 课程注意事项
    {
      path: Config.courseTipList.path,
      name: Config.courseTipList.name,
      component: CourseTip,
    },
    {
      path: Config.courseTipDeletedList.path,
      name: Config.courseTipDeletedList.name,
      component: CourseTipDeletedList,
    },
    {
      path: Config.courseTipAdd.path,
      name: Config.courseTipAdd.name,
      component: CourseTipAdd,
    },
    {
      path: Config.courseTipEdit.path,
      name: Config.courseTipEdit.name,
      component: CourseTipEdit,
    },

    // 课程白名单
    {
      path: Config.courseWhitelistList.path,
      name: Config.courseWhitelistList.name,
      component: CourseWhitelist,
    },
    {
      path: Config.courseWhitelistDeletedList.path,
      name: Config.courseWhitelistDeletedList.name,
      component: CourseWhitelistDeletedList,
    },
    {
      path: Config.courseWhitelistAdd.path,
      name: Config.courseWhitelistAdd.name,
      component: CourseWhitelistAdd,
    },
    {
      path: Config.courseWhitelistManage.path,
      name: Config.courseWhitelistManage.name,
      component: CourseWhitelistManage,
    },

    // 课程封面
    {
      path: Config.courseCoverList.path,
      name: Config.courseCoverList.name,
      component: CourseCover,
    },
    {
      path: Config.courseCoverDeletedList.path,
      name: Config.courseCoverDeletedList.name,
      component: CourseCoverDeletedList,
    },
    {
      path: Config.courseCoverAdd.path,
      name: Config.courseCoverAdd.name,
      component: CourseCoverAdd,
    },
    {
      path: Config.courseCoverEdit.path,
      name: Config.courseCoverEdit.name,
      component: CourseCoverEdit,
    },

    // 课程封面视频
    {
      path: Config.courseVideoList.path,
      name: Config.courseVideoList.name,
      component: CourseVideo,
    },
    {
      path: Config.courseVideoDeletedList.path,
      name: Config.courseVideoDeletedList.name,
      component: CourseVideoDeletedList,
    },
    {
      path: Config.courseVideoAdd.path,
      name: Config.courseVideoAdd.name,
      component: CourseVideoAdd,
    },
    {
      path: Config.courseVideoEdit.path,
      name: Config.courseVideoEdit.name,
      component: CourseVideoEdit,
    },

    // 门店二维码
    {
      path: Config.storeQrCodeList.path,
      name: Config.storeQrCodeList.name,
      component: StoreQrCode,
    },

    // 门店
    {
      path: Config.storeList.path,
      name: Config.storeList.name,
      component: Store,
    },
    {
      path: Config.storeDeletedList.path,
      name: Config.storeDeletedList.name,
      component: StoreDeletedList,
    },
    {
      path: Config.storeAdd.path,
      name: Config.storeAdd.name,
      component: StoreAdd,
    },
    {
      path: Config.storeEdit.path,
      name: Config.storeEdit.name,
      component: StoreEdit,
    },

    // 门店封面
    /*{
      path: Config.storeCoverList.path,
      name: Config.storeCoverList.name,
      component: StoreCover,
    },
    {
      path: Config.storeCoverDeletedList.path,
      name: Config.storeCoverDeletedList.name,
      component: StoreCoverDeletedList,
    },
    {
      path: Config.storeCoverAdd.path,
      name: Config.storeCoverAdd.name,
      component: StoreCoverAdd,
    },
    {
      path: Config.storeCoverEdit.path,
      name: Config.storeCoverEdit.name,
      component: StoreCoverEdit,
    },*/

    // 微信支付订单
    {
      path: Config.weChatOrderList.path,
      name: Config.weChatOrderList.name,
      component: WeChatOrder,
    },
    {
      path: Config.weChatOrderRefundList.path,
      name: Config.weChatOrderRefundList.name,
      component: WeChatOrderRefundList,
    },

    // 有赞签到日期
    {
      path: Config.youZanSignDateList.path,
      name: Config.youZanSignDateList.name,
      component: YouZanSignDate,
    },
    {
      path: Config.youZanSignDateDeletedList.path,
      name: Config.youZanSignDateDeletedList.name,
      component: YouZanSignDateDeletedList,
    },
    {
      path: Config.youZanSignDateVerifiedList.path,
      name: Config.youZanSignDateVerifiedList.name,
      component: YouZanSignDateVerifiedList,
    },
    {
      path: Config.youZanSignDateSignedList.path,
      name: Config.youZanSignDateSignedList.name,
      component: YouZanSignDateSignedList,
    },
    {
      path: Config.youZanSignDateAdd.path,
      name: Config.youZanSignDateAdd.name,
      component: YouZanSignDateAdd,
    },
    {
      path: Config.youZanSignDateEdit.path,
      name: Config.youZanSignDateEdit.name,
      component: YouZanSignDateEdit,
    },

    // 错误日志
    {
      path: Config.errorLogList.path,
      name: Config.errorLogList.name,
      component: ErrorLog,
    },
    {
      path: Config.errorLogDetail.path,
      name: Config.errorLogDetail.name,
      component: ErrorLogDetail,
    },
    {
      path: Config.errorLogYouZanList.path,
      name: Config.errorLogYouZanList.name,
      component: ErrorLogYouZanList,
    },
    {
      path: Config.errorWeChatOrderList.path,
      name: Config.errorWeChatOrderList.name,
      component: ErrorWeChatOrderList,
    },
    {
      path: Config.errorLogYouZanDetail.path,
      name: Config.errorLogYouZanDetail.name,
      component: ErrorLogYouZanDetail,
    },
    {
      path: Config.errorLogWeChatOrderDetail.path,
      name: Config.errorLogWeChatOrderDetail.name,
      component: ErrorLogWeChatOrderDetail,
    },
    {
      path: Config.errorWorkWeChatList.path,
      name: Config.errorWorkWeChatList.name,
      component: ErrorWorkWeChatList,
    },
    {
      path: Config.errorWorkWeChatDetail.path,
      name: Config.errorWorkWeChatDetail.name,
      component: ErrorWorkWeChatDetail,
    },
    {
      path: Config.errorWeChatSubscribeList.path,
      name: Config.errorWeChatSubscribeList.name,
      component: ErrorWeChatSubscribeList,
    },
    {
      path: Config.errorSmsList.path,
      name: Config.errorSmsList.name,
      component: ErrorSmsList,
    },

    // 小程序页面
    {
      path: Config.appPageList.path,
      name: Config.appPageList.name,
      component: AppPage,
    },
    {
      path: Config.appPageDeletedList.path,
      name: Config.appPageDeletedList.name,
      component: AppPageDeletedList,
    },
    {
      path: Config.appPageAdd.path,
      name: Config.appPageAdd.name,
      component: AppPageAdd,
    },
    {
      path: Config.appPageEdit.path,
      name: Config.appPageEdit.name,
      component: AppPageEdit,
    },
  ]
});

// 动态设置浏览器标签页标题（主流做法：页面名在前、系统名在后）。
// 页面名放在最前，标签页变窄被浏览器截断时也能看到当前页面，避免统一为系统名导致多标签无法区分。
// 无对应页面名时（初始加载 / 异常路由）回退为系统名。
const BASE_TITLE = '嘉禾舞社后台管理系统';

router.afterEach((to) => {
  if (!to.name) {
    document.title = BASE_TITLE;
    return;
  }
  // config 的 key 是小驼峰（如 studentList），路由 name 是大驼峰（如 StudentList），需转换
  const configKey = `${to.name[0].toLowerCase()}${to.name.slice(1)}`;
  const label = Config[configKey] && Config[configKey].label;
  document.title = label ? `${label} - ${BASE_TITLE}` : BASE_TITLE;
});

export default router;
